import { styled } from '@volkswagen-onehub/components-core';

export const ContentListStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: flex-start;
  ${({ theme }) => {
    return `
      gap: ${theme.size.static350};
      color: ${theme.colors.content.tertiary};
    `;
  }}
`;

export const ContentListBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ theme }) => {
    return `
      gap: ${theme.size.static200};
    `;
  }}
`;
